import {Link} from '@mui/material';
import * as React from 'react';

export const CourseChatLink = ({
  courseName,
  url,
}: {
  courseName: string | undefined;
  url?: string | null;
}) => {
  if (courseName == null) {
    return null;
  }

  return (
    <>
      <b>Liên lạc</b>
      <p>
        Nhóm Zalo <b>{courseName}</b> :{' '}
        {url ? (
          <Link href={url} target="_blank" rel="noopener noreferrer">
            Nhấn để tham gia
          </Link>
        ) : (
          'chưa có'
        )}
      </p>
    </>
  );
};
